import React, { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import logo from "../../assets/images/Logo.png";
import loginStyles from "../../styles/loginStyles";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../store/slices/authSlice";
import { useNavigate } from "react-router-dom";
import api from "../../api/axiosConfig";
import { endpoints } from "../../api/endpoints";

const Login: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await api.post(endpoints.auth.login, {
        email,
        password,
        client_type: "admin_web",
      });

      const {
        access_token,
        refresh_token,
        name,
        email: apiEmail,
        role,
        user_role,
        designation,
        phone,
        mobile,
        phone_number,
        join_date,
        joining_date,
        joined_at,
        created_at,
      } = response.data;

      if (!access_token) {
        throw new Error("Access token missing in login response.");
      }

      localStorage.setItem("refresh_token", refresh_token || "");

      // Dispatch login success action
      dispatch(
        loginSuccess({
          user: {
            id: apiEmail || email,
            name: name || "User",
            email: apiEmail || email,
            role:
              role === "ADMIN"
                ? "System Administrator"
                : role || user_role || designation || "System Administrator",
            phone: phone || mobile || phone_number || "+91 98765 43210",
            joinDate:
              join_date ||
              joined_at ||
              joining_date ||
              created_at ||
              "2024-01-15",
          },
          token: access_token,
          refreshToken: refresh_token,
        }),
      );

      setLoading(false);
      // navigate('/dashboard');
    } catch (err: any) {
      console.error("Login error:", err);
      setLoading(false);
      const errorMessage =
        err.response?.data?.detail?.message ||
        err.response?.data?.message ||
        err.response?.data?.detail ||
        err.message ||
        "Invalid credentials. Please try again.";
      setError(errorMessage);
    }
  };

  return (
    <div style={loginStyles.pageBG}>
      <div style={loginStyles.container}>
        <div style={loginStyles.logoBox}>
          <img src={logo} alt="Logo" style={loginStyles.logo} />
          <h2 style={loginStyles.heading}>Sign in to your account</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={loginStyles.field}>
            <label htmlFor="email" style={loginStyles.label}>
              Email Address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder="admin@craksha.com"
              style={loginStyles.input}
            />
          </div>
          <div style={loginStyles.field}>
            <label htmlFor="password" style={loginStyles.label}>
              Password
            </label>
            <div style={{ position: "relative", width: "100%" }}>
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                placeholder="••••••••••••"
                style={{
                  ...loginStyles.input,
                  ...loginStyles.passwordInput,
                  width: "100%",
                  paddingRight: 44,
                  boxSizing: "border-box",
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((previous) => !previous)}
                disabled={loading}
                aria-label={showPassword ? "Hide password" : "Show password"}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: 12,
                  transform: "translateY(-50%)",
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#6B7280",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                {showPassword ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </button>
            </div>
          </div>
          <div style={loginStyles.forgotPasswordLink}>
            <button
              type="button"
              onClick={() => navigate("/forgot-password")}
              disabled={loading}
              style={{
                background: "none",
                border: "none",
                color: "#2E7D32",
                cursor: loading ? "not-allowed" : "pointer",
                fontSize: 14,
                fontWeight: 500,
                textDecoration: "underline",
                opacity: loading ? 0.6 : 1,
              }}
            >
              Forgot Password?
            </button>
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              ...loginStyles.button,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "SIGNING IN..." : "SIGN IN"}
          </button>
          {error && (
            <div style={loginStyles.error}>
              <span style={{ fontWeight: "bold", fontSize: 18 }}>⚠</span>
              <span>{error}</span>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;
